import api from '../../request/request'

const findWarehouseByTeamId = (teamId) => {
    return api.getPromise('cloudWarehouse/findWarehouseByTeamId',
        { teamId })
}

export default {
    findWarehouseByTeamId
}




// WEBPACK FOOTER //
// ./src/request/newSys/erpCloudWarehouseApi.js